import React from 'react';
import TransitionLink from 'gatsby-plugin-transition-link';
import anime from 'animejs';

export default ({ duration = 0.8, ...props }) => {
  const fade = ({ node, exit = false }) =>
    anime({
      targets: node.querySelectorAll('section, footer'),
      duration: (duration / 2) * 1000,
      opacity: exit ? [1, 0] : [0, 1],
      easing: exit ? 'easeInCubic' : 'easeOutSine',
    });

  return (
    <TransitionLink
      exit={{
        length: duration / 2,
        trigger: ({ node }) => fade({ node, exit: true }),
      }}
      entry={{
        delay: duration / 2,
        trigger: ({ node }) => fade({ node }),
      }}
      {...props}
    >
      {props.children}
    </TransitionLink>
  );
};
